export const environment = {
  production: false,
  apiUrl:'https://api-price-balancing.techbar.com/',
  socketUrl: 'wss://api-price-balancing.techbar.com',
};
